"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("@retisio/ui/dist/lib");
var _ui = require("@retisio/ui");
var _topnavModule = _interopRequireDefault(require("./topnav.module.scss"));
var _rbac = require("@retisio/rbac");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ArcTopNavigation(props) {
  var logo = props.logo,
    appId = props.appId,
    options = props.options;
  var showTopNav = function showTopNav() {
    if (window.location.pathname.indexOf('login') > -1 || window.location.pathname.indexOf('forgotpassword') > -1 || window.location.pathname.indexOf('resetpassword') > -1) {
      return true;
    }
    return false;
  };
  var showLogout = function showLogout(logout) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      href: "/",
      onClick: function onClick(e) {
        e.preventDefault();
        logout(e);
      }
    }, "Logout");
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_topnavModule["default"].wrapper, " ").concat(showTopNav() ? _topnavModule["default"].hide : _topnavModule["default"].show)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _topnavModule["default"].logo
  }, /*#__PURE__*/_react["default"].createElement(_ui.ArcIcon, {
    name: logo ? logo : 'logo',
    size: {
      width: 100,
      height: 50
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _topnavModule["default"].menuItems
  }, /*#__PURE__*/_react["default"].createElement("ul", null, options && options.length === 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_lib.Skeleton.Input, {
    active: true
  })), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_lib.Skeleton.Input, {
    active: true
  })), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_lib.Skeleton.Input, {
    active: true
  })), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_lib.Skeleton.Input, {
    active: true
  })), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_lib.Skeleton.Input, {
    active: true
  }))), options === null || options === void 0 ? void 0 : options.map(function (menu, i) {
    return !(menu !== null && menu !== void 0 && menu.hidden) && /*#__PURE__*/_react["default"].createElement("a", {
      key: 'navbar ' + i,
      href: "".concat(menu.href),
      title: menu.appId
    }, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("span", {
      className: _topnavModule["default"].menuName
    }, menu.value), /*#__PURE__*/_react["default"].createElement("div", {
      className: window.location.pathname.indexOf(menu.appId) > -1 && menu.appId === appId ? _topnavModule["default"].active : ''
    })));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _topnavModule["default"].userprofile
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "/docs"
  }, /*#__PURE__*/_react["default"].createElement(_ui.ArcIcon, {
    name: "resources",
    size: {
      width: 24,
      height: 24
    },
    alt: "RESOURCES"
  })), /*#__PURE__*/_react["default"].createElement(_rbac.AuthConsumer, null, function (_ref) {
    var user = _ref.user;
    return user && user.profile && /*#__PURE__*/_react["default"].createElement("span", null, user.profile.firstName + ' ' + user.profile.lastName);
  }), /*#__PURE__*/_react["default"].createElement(_ui.ArcPopover, {
    content: /*#__PURE__*/_react["default"].createElement(_rbac.AuthConsumer, null, function (_ref2) {
      var logout = _ref2.logout;
      return showLogout(logout);
    }),
    placement: "bottom",
    trigger: "click"
  }, /*#__PURE__*/_react["default"].createElement(_ui.ArcIcon, {
    name: "user",
    size: {
      width: 24,
      height: 24
    }
  }))));
}
var _default = ArcTopNavigation;
exports["default"] = _default;